<template>
  <section class="content">
    <div class="box box-primary">
      <div class="box-header with-border">
        <h3 class="box-title">{{'invoices_download' | translate}}</h3>
      </div>
      <div class="box-controls">
        <div class="row">
          <div class="col-xs-12 filter-box">
            <div class="collapse in" id="coll1">
              <div class="col-md-2 col-sm-6">
                <div class="input-group">
                  <input
                    type="text"
                    name="search"
                    v-model="invoiceNumber"
                    class="form-control"
                    :placeholder="'invoice_id' | translate"
                    @keyup.13.prevent="paginate('','')"
                    @blur="paginate('','')"
                  >
                  <div class="input-group-btn">
                    <button type="submit" name="submit" class="btn">
                      <i class="fa fa-search"></i>
                    </button>
                  </div>
                </div>
              </div>
              <template v-if="$route.params.type === 'customers'">
                <div class="col-md-3 col-sm-6">
                  <div class="input-group">
                    <input
                      type="text"
                      name="search"
                      v-model="selectedOrder"
                      class="form-control"
                      :placeholder="'order_id' | translate"
                      @keyup.13.prevent="paginate('','')"
                      @blur="paginate('','')"
                    >
                    <div class="input-group-btn">
                      <button type="submit" name="submit" class="btn">
                        <i class="fa fa-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 col-sm-6">
                  <div class="input-group">
                    <div class="input-group-addon">
                      {{'sales_channel' | translate}}
                    </div>
                    <select class="form-control" v-model="selectedChannel" @change.prevent="paginate('channel')">
                      <template v-for="option in channels">
                        <option :value="option.val" class="normal">{{option.label | translate}}</option>
                      </template>
                    </select>
                  </div>
                </div>
                <div class="col-md-3 col-sm-6">
                  <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
                </div>
              </template>
              <template v-else>
                <div class="col-md-2 col-sm-6">
                  <div class="input-group">
                    <input
                      type="text"
                      name="search"
                      v-model="sapNumber"
                      class="form-control"
                      :placeholder="'sap_number' | translate"
                      @keyup.13.prevent="paginate('','')"
                      @blur="paginate('','')"
                    >
                    <div class="input-group-btn">
                      <button type="submit" name="submit" class="btn">
                        <i class="fa fa-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-2 col-sm-6">
                  <div class="input-group">
                    <input
                      type="text"
                      name="search"
                      v-model="selectedCompany"
                      class="form-control"
                      :placeholder="'company' | translate"
                      @keyup.13.prevent="paginate('','')"
                      @blur="paginate('','')"
                    >
                    <div class="input-group-btn">
                      <button type="submit" name="submit" class="btn">
                        <i class="fa fa-search"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-2 col-sm-6">
                  <div class="input-group">
                    <div class="input-group-addon">
                      {{'month' | translate}}
                    </div>
                    <vue-monthly-picker
                      dateFormat="MM-YYYY"
                      class="form-control"
                      v-model="selectedMonth"
                      @selected="paginate('', 'date')"
                      :max="max"
                      :monthLabels="monthLabels"
                    >
                    </vue-monthly-picker>
                  </div>
                </div>
                <div class="col-md-4 col-sm-6">
                  <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
                </div>
              </template>
            </div>
          </div>
          <div class="text-right">
          </div>
        </div>
      </div>
      <div class="box-body">
        <div class="table-responsive">
          <table class="table table-hover">
            <thead>
            <tr>
              <template v-if="$route.params.type === 'customers'">
                <th>{{'qb_id' | translate}}</th>
                <th>{{'mp_id' | translate}}</th>
                <th>{{'date' | translate}}</th>
                <th>{{'invoice_number' | translate}}</th>
                <th>{{'sales_channel' | translate}}</th>
                <th>{{'download' | translate}}</th>
              </template>
              <template v-else>
                <th>{{'company' | translate}}</th>
                <th>{{'invoice_number' | translate}}</th>
                <th>{{'sap_number' | translate}}</th>
                <th>{{'date' | translate}}</th>
                <th>{{'invoice' | translate}}</th>
                <th>{{'poic' | translate}}</th>
              </template>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in pagination.data">
              <template v-if="$route.params.type === 'customers'">
                <td>{{ item.order_id}}</td>
                <td>{{ item.ext_order_id}}</td>
                <td class="small">
                  {{item.invoice_date | orderDate}}<br>
                  <i class="fa fa-clock-o mr-5"></i>{{item.invoice_date | orderDate(true)}}
                </td>
                <td>{{ item.invoice_number }}</td>
                <td>
                  <img class="img-responsive img-channel" :src="`/static/img/${getChannel(item.sales_channel)}.svg`">
                </td>
                <td>
                  <a class="btn btn-success" target="_blank" :href="item.path">
                    <i class="fa fa-cloud-download mr-5"></i>{{'download' | translate}}
                  </a>
                </td>
              </template>
              <template v-else>
                <td>{{item.company_name}}</td>
                <td>{{item.invoice_number}}</td>
                <td>{{item.sap_number}}</td>
                <td>{{item.document_date | orderDateWithoutTime}}</td>
                <td>
                  <a
                    class="btn btn-success"
                    target="_blank"
                    :href="item.s3_invoice_path"
                  >
                    <i class="fa fa-cloud-download mr-5"></i>{{'pdf_download' | translate}}
                  </a>
                  <a
                    class="btn btn-success"
                    target="_blank"
                    v-if="item.s3_sum_csv_path !==''"
                    :href="item.s3_sum_csv_path"
                  >
                    <i class="fa fa-cloud-download mr-5"></i>{{'download_sum_as_csv' | translate}}
                  </a>
                </td>
                <td>
                  <a
                    class="btn btn-success"
                    target="_blank"
                    :href="item.s3_csv_path"
                  >
                    <i class="fa fa-cloud-download mr-5"></i>{{'csv_download' | translate}}
                  </a>
                </td>
              </template>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="box-footer">
        <my-pagination :total="pagination.total" :per-page="pagination.per_page" :pagination="pagination"></my-pagination>
      </div>
    </div>
  </section>
</template>
<script>
	import VueMonthlyPicker from 'vue-monthly-picker'
	export default {
		data () {
			return {
				selectedMonth: moment().subtract(1, 'month'),
        monthLabels: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sept', 'Okt', 'Nov', 'Dez'],
				channels: [
          {label: 'all', val: 0},
          {label: 'ebay', val: 5},
          {label: 'zalando', val: 6},
          {label: 'amazon', val: 7},
          {label: 'schuhede-parent', val: 8},
          {label: 'selfservice-schuhede', val: 8},
          {label: 'kaufland_de', val: 53},
          {label: 'limango_de', val: 51},
          {label: 'sport2000', val: 43},
          {label: 'ats_de', val: 57},
          {label: 'spartoo', val: 9},
        ],
				alerts: [],
				ready: [],
				count: 25,
				selectedId: '',
				selectedChannel: 0,
				selectedOrder: 0,
				selectedMPId: '',
				selectedCompany: '',
				table: '',
				max: moment(),
				invoiceNumber: '',
        sapNumber: '',
				page: 0,
				sortKey: '',
				pagination: {
					total: 0,
					per_page: 25,
					current_page: 1,
					total_pages: 0
				},
				filePath: []
			}
		},
		components: {
			VueMonthlyPicker: VueMonthlyPicker
		},
		methods: {
			getChannel (id) {
				switch (id) {
					case 1:
						return 'schuhede'
					case 2:
						return 'schuhede-ebay'
					case 3:
						return 'schuhede-zalando'
					case 4:
						return 'schuhede-amazon'
					case 5:
						return 'ebay'
					case 6:
						return 'zalando'
					case 7:
						return 'amazon'
					case 8:
						return 'schuhede-parent'
					case 9:
						return 'spartoo'
					case 10:
						return 'spartoo'
          case 43:
						return 'sport2000'
					case 44:
						return 'sport2000'
					case 49:
						return 'selfservice-schuhede'
					case 50:
						return 'selfservice-schuhede'
					case 51:
						return 'limango_de'
					case 52:
						return 'limango_de'
					case 53:
						return 'kaufland_de'
					case 54:
						return 'kaufland_de'
					case 57:
						return 'ats_de'
					case 58:
						return 'ats_de'
				}
			},
			download (id, index) {
				API.get(`download/invoices/${this.$route.params('type')}/${id}`, {})
					.then(response => {
						this.filePath[index] = response.data.invoice_path
						this.filePath = [...this.filePath]
						this.ready[index] = 'download'
						this.ready = [...this.ready]
					})
          .catch(error => {
            if (this.checkError(error)) {
              let alert = {type: 'danger', dismiss: 4, message: this.translate(error.body.error_code) || error.body.error_message}
              this.$store.commit('pushAlert', alert)
            }
          })
			},
			formatForSending (date) {
				let d = date.split('/')
				let aux = d[1]
				d[1] = d[0]
				d[0] = d[2]
				d[2] = aux
				return date === '' ? '' : d.join('-')
			},
			updateValue (event, type) {
				type === 'start' ? this.date.startDate = event.target.value : this.date.endDate = event.target.value
				this.paginate('date', '', event)
			},
			paginate (type, value) {
				let curl = `downloads/sap/invoices/customers?invoice_number=${this.invoiceNumber}&ext_order_id=${this.selectedOrder}&sales_channel_id=${this.selectedChannel}`
				let murl = `downloads/sap/invoices/merchants?invoice_number=${this.invoiceNumber}&sap_number=${this.sapNumber}&company_name=${encodeURIComponent(this.selectedCompany)}`
        murl += value === 'date' && typeof this.selectedMonth !== 'undefined' ? `&date=${this.selectedMonth.format('YYYY-MM')}` : ''
        let surl = `downloads/sap/invoices/service?invoice_number=${this.invoiceNumber}&sap_number=${this.sapNumber}&company_name=${encodeURIComponent(this.selectedCompany)}`
        surl += value === 'date' && typeof this.selectedMonth !== 'undefined' ? `&date=${this.selectedMonth.format('YYYY-MM')}` : ''
        let url=null
        if(this.$route.params.type==="customers"){
          url=curl
        }
        if(this.$route.params.type==="merchants"){
          url=murl
        }
        if(this.$route.params.type==="service"){
          url=surl
        }
				if (type === 'page') {
					url += '&page='
					if (value === 'previous') {
						url += (this.pagination.current_page - 1)
					}
					if (value === 'next') {
						url += this.pagination.current_page >= this.pagination.last_page ? this.pagination.last_page : (this.pagination.current_page + 1)
					} else if (value !== 'next' && value !== 'previous') {
						url += value
					}
				}
				API.get(url, {})
					.then(response => {
            if (this.$route.params.type === 'merchants'||this.$route.params.type==='service') {
              response.data.data = this.sort(response.data.data)
            }
            this.pagination = response.data
					})
          .catch(error => {
            this.checkError(error)
          })
			},
      sort (arr) {
        return arr.sort((a,b) => {
          return parseInt(a.invoice_number) - parseInt(b.invoice_number)
        }).reverse()
      },
			getInvoices () {
				this.invoiceNumber = ''
				this.selectedOrder = ''
				this.selectedChannel = 0
				this.selectedCompany = ''
				this.selectedMonth = moment().subtract(1, 'month')
				API.get(`downloads/sap/invoices/${this.$route.params.type}`, {})
					.then(response => {
					  if (this.$route.params.type === 'merchants'||this.$route.params.type === 'service') {
              response.data.data = this.sort(response.data.data)
            }
            this.pagination = response.data
					})
          .catch(error => {
					  this.checkError(error)
				  })
			}
		},
		mounted () {
			this.$nextTick(function () {
				this.getInvoices()
			})
		},
		watch: {
			'$route.params' () {
				this.getInvoices()
			}
		}
	}
</script>
<style>
  .date-popover {
    overflow-x: hidden;
    overflow-y: hidden;
    outline: none;
    max-width: 350px;
    width: 100%;
    border-radius: 0 0 .28571429rem .28571429rem;
    box-shadow: 0 2px 3px 0 rgba(34,36,38,.15);
    background: #212228 !important;
    transition: opacity .1s ease;
    position: relative;
    margin: auto;
    z-index: 10;
    border: 1px solid;
    font-size: 1rem;
    font-weight: 200;
  }
  .picker .monthItem .item.active:hover{
    border-top: 1px solid;
    cursor: pointer;
    background-color: rgba(0,195,150,.4) !important;
    border-color: rgba(0,195,150,1) !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/Accounting/SapInvoices.vue